import { Component } from '@angular/core';

@Component({
  selector: 'app-contact-types',
  templateUrl: './contact-types.component.html',
  styleUrls: ['./contact-types.component.scss']
})
export class ContactTypesComponent {
}
